import { styled } from '@mui/material';

export const StyledAppointmentsPageInnerWrap = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
}));

export const StyledAppointmentsHourWrap = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
});
